export default __webpack_public_path__ + "static/media/eye-open.39a4bfde.svg";